// Meta's JavaScript SDK, loaded only when someone connects WhatsApp.
//
// Embedded Signup ("Connect WhatsApp") runs inside FB.login. The SDK is
// fetched only on the WhatsApp settings page, while a connect button is shown,
// so the rest of the app makes no request to Facebook.

const SDK_URL = 'https://connect.facebook.net/en_US/sdk.js';

let loading = null;

export function loadFacebookSdk(appId, version) {
  if (window.FB) {
    window.FB.init({ appId, autoLogAppEvents: false, xfbml: false, version });
    return Promise.resolve(window.FB);
  }
  if (loading) return loading;
  loading = new Promise((resolve, reject) => {
    window.fbAsyncInit = () => {
      window.FB.init({ appId, autoLogAppEvents: false, xfbml: false, version });
      resolve(window.FB);
    };
    const script = document.createElement('script');
    script.src = SDK_URL;
    script.async = true;
    script.defer = true;
    script.crossOrigin = 'anonymous';
    script.onerror = () => {
      loading = null;
      reject(new Error('Could not load Facebook sign-in. Check that nothing is blocking facebook.com and try again.'));
    };
    document.body.appendChild(script);
  });
  return loading;
}

// Only Facebook's own pages may report the signup result to us.
export function isFacebookOrigin(origin) {
  return /^https:\/\/([a-z0-9-]+\.)*facebook\.com$/.test(String(origin || ''));
}

// Parses one window message from Embedded Signup. Returns null for anything else.
export function readSignupMessage(event) {
  if (!isFacebookOrigin(event?.origin)) return null;
  let data = event.data;
  if (typeof data === 'string') {
    try {
      data = JSON.parse(data);
    } catch {
      return null;
    }
  }
  if (!data || data.type !== 'WA_EMBEDDED_SIGNUP') return null;
  return { event: String(data.event || ''), data: data.data || {} };
}
